import { Slide } from '@mui/material'
import { TransitionProps } from '@mui/material/transitions'
import { ReactElement, Ref } from 'react'

function DialogMenuTransition({
  ref,
  ...props
}: TransitionProps & {
  children: ReactElement
  ref?: Ref<unknown>
}) {
  return <Slide direction="left" ref={ref} {...props} />
}

export default DialogMenuTransition
